import { loan_request } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function registerLoanRequest({
  url: { service: baseURL },
  token,
}: IAPI) {
  return async function registerLoanRequest(
    loanRequest: loan_request.CreateLoanRequest
  ): Promise<loan_request.LoanRequest> {
    const url = new URL(`/loan-quote/request/`, baseURL);

    const response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(loanRequest),
    });

    const responseJson = await response.json();

    if (response.ok) return responseJson;
    throw new Error(
      `Error posting ${response.url}: ${response.status} ${
        response.statusText
      } ${responseJson.error || responseJson.Message}`
    );
  };
}
